import { AvatarTypes } from "@chesshotel/constants";
import Avatar from "../../../components/common/avatar";
import { cn } from "@/lib/utils";

export default function PlayerAvatar({
  isUser,
  isGuest,
  gameEnded,
  avatarId = null,
  fbId = null,
  googleId = null,
  avatarType = AvatarTypes.GUEST,
  id = null,
  className = "",
  status,
}) {
  const link =
    !isGuest && !isUser && gameEnded ? `/user?userId=${id}&link=game` : null;

  return (
    <Avatar
      id={id}
      avatarType={avatarType}
      avatarId={avatarId}
      fbId={fbId}
      googleId={googleId}
      link={link}
      status={status}
      className={cn("m-0 w-8 h-8 md:w-11 md:h-11", className)}
    />
  );
}
